/**
 * Floating WhatsApp chat button — opens a wa.me link with a pre-filled message.
 * The business number is configurable via REACT_APP_WHATSAPP_NUMBER (env).
 * Falls back to a hidden state if no number configured.
 */
import { MessageCircle } from "lucide-react";
import { useState } from "react";

const WA_NUMBER = process.env.REACT_APP_WHATSAPP_NUMBER || "";
const DEFAULT_MSG = "Hi MarkeeMix team! I have a question about your tools.";

export default function WhatsAppButton({ offsetRight = 96 }) {
  const [hover, setHover] = useState(false);
  if (!WA_NUMBER) return null;

  const cleanNum = WA_NUMBER.replace(/[^0-9]/g, "");
  const href = `https://wa.me/${cleanNum}?text=${encodeURIComponent(DEFAULT_MSG)}`;

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-floating-button"
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      style={{
        position: "fixed",
        bottom: 24,
        right: offsetRight,
        width: 56,
        height: 56,
        borderRadius: "50%",
        background: "#25D366",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        boxShadow: hover
          ? "0 10px 32px rgba(37,211,102,0.55), 0 0 0 8px rgba(37,211,102,0.18)"
          : "0 6px 18px rgba(37,211,102,0.4)",
        color: "#fff",
        textDecoration: "none",
        zIndex: 90,
        transition: "transform 0.18s ease, box-shadow 0.18s ease",
        transform: hover ? "scale(1.08)" : "scale(1)",
        cursor: "pointer",
      }}
      aria-label="Chat on WhatsApp"
    >
      {/* WhatsApp glyph (lucide MessageCircle is close enough) */}
      <MessageCircle size={26} fill="white" stroke="white"/>
      {hover && (
        <span style={{
          position: "absolute",
          right: 68,
          top: "50%",
          transform: "translateY(-50%)",
          background: "#0F172A",
          color: "#fff",
          padding: "6px 12px",
          borderRadius: 8,
          fontSize: 12,
          fontWeight: 600,
          whiteSpace: "nowrap",
        }}>Chat on WhatsApp</span>
      )}
    </a>
  );
}
